import * as rq from '@tanstack/react-query';

import { IPCSRepository } from '@/pcs/domain/repositories/pcs.repository';

import { useDependencies } from '../contexts/dependencies.context';

export namespace GetAllPCS {
  export const key = (input: Input) => [
    'pcs',
    'get-all-pcs',
    input.filters,
    input.assetFullFrontendId,
  ];

  export type Params = { refetchInterval?: number };
  export type Input = IPCSRepository.GetAllInput;
  export type Output = IPCSRepository.GetAllOutput;

  export function useQuery(input: Input, { refetchInterval }: Params = {}) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(input),
      queryFn: () => repositories.pcs.getAll(input),
    });
  }
}
